import type { Session, Vote } from '../types';

/** Proposal IDs the current user voted / showed interest for. */
export function getVotedProposalIds(myVotes: Vote[]): Set<string> {
  const set = new Set<string>();
  myVotes.forEach((v) => {
    if (v.targetType === 'proposal' && v.weight > 0) set.add(v.targetId);
  });
  return set;
}

/**
 * Session IDs the user is interested in — direct session votes or votes on
 * any underlying proposal.
 */
export function getVotedSessionIds(myVotes: Vote[], sessions: Session[]): Set<string> {
  const votedProposals = getVotedProposalIds(myVotes);
  const directSessionVotes = new Set<string>();
  myVotes.forEach((v) => {
    if (v.targetType === 'session' && v.weight > 0) directSessionVotes.add(v.targetId);
  });

  const set = new Set<string>(directSessionVotes);
  for (const session of sessions) {
    if (set.has(session.id)) continue;
    if (session.proposals.some((p) => votedProposals.has(p.id))) {
      set.add(session.id);
    }
  }
  return set;
}

/** Session IDs matching the "My Interests" board filter (interest + going). */
export function getMySessionFilterIds(
  votedSessionIds: Set<string>,
  bookmarkedSessionIds: Set<string>
): Set<string> {
  return new Set([...votedSessionIds, ...bookmarkedSessionIds]);
}
